<template>
  <v-card :class="`py-5 ${selected? 'selected': ''}`" @click="cardClicked">
    <v-icon :color="$finColors.primaryDark" :size="30" style="position: absolute; right: -10px; top: -10px;"
            v-if="selected">icon-check-ellipse
    </v-icon>
    <v-img :elevation="6"
           :opacity="0.3"
           :src="require('@/assets/onboarding/strategy/' + imgType + '-invest.svg')"
           :style="{margin: '0 auto', opacity: selected ? 1 : 0.3}"
           class="mb-4"
           contain
           height="50px"
           width="50px"
    />
    <h6 style="text-align: center;" v-if="imgType === 'custom'">Eigener Betrag</h6>
    <h6 v-else style="text-align: center;">{{ amount|finCurrency }}</h6>
  </v-card>
</template>

<script>
export default {
  name: 'finMoneyCard',
  props: {
    /** the type of the investment money image: use small, medium, huge or custom */
    imgType: {
      type: String,
      default: 'small'
    },
    /** if the current money card is selected */
    selected: {
      type: Boolean,
      default: false
    },
    /** the amount of money the user is able to choose to invests */
    amount: {
      type: Number,
      default: 5000
    }
  },
  methods: {
    cardClicked() {
      /**
       * Emits the click event for this money card.
       *
       * @event click
       * @type {object} containing the name and the amount of the money card clicked
       */
      this.$emit('click', {
        name: this.imgType,
        amount: this.amount
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables";


h6 {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-dark;
}

.selected {
  border: 3px solid $fin-color-primary-dark !important;
}
</style>
